import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { map, range, pick } from 'lodash';
import { _DisplayFlex } from '../../common/styled-flex';
import { getCells } from '../../../core/cells';
import { getChart, setTemplate } from '../../../core/chart';

import PreviewChart from '../../fanchart/preview';
import AutoScale from 'react-auto-scale';
import { StyledScrollable, StyledMargin } from '../../common/styled-base';
import { StyledPreview } from '../styled-sidebar';

import templates from '../../../core/templates';

class TemplateMenu extends React.Component {

  render() {
    const { chart, cells, setTemplate } = this.props;

    const colors = range(0, 7).map(generation => {
      const n = Math.pow(2, generation);
      return range(0, n).map(i => pick(cells[n + i], ['background', 'textColor', 'bandColor']));
    })

    return (
      <_DisplayFlex direction="column" flex="1">
        <StyledScrollable style={{maxHeight: 'calc(100vh - 55px)'}}>
          {map(templates, (template, key) => (
            <StyledPreview key={key} onClick={() => setTemplate(key)}>
              <StyledMargin marginBottom="10px">
                <AutoScale>
                  <PreviewChart 
                    chart={{...chart, ...template.settings, generations: 7}}
                    generations={template.generations.slice(0, 7)}
                    palette={{colors}}
                    />
                </AutoScale>
              </StyledMargin>
              {template.settings.name}
            </StyledPreview>
          ))}
        </StyledScrollable>
      </_DisplayFlex>
    )
  }
}

const mapStateToProps = createSelector(
  getChart,
  getCells,
  (chart, cells) => ({
    chart,
    cells,
  })
)

const mapDispatchToProps = Object.assign({setTemplate});

export default connect(mapStateToProps, mapDispatchToProps)(TemplateMenu);


// WEBPACK FOOTER //
// ./src/components/menu/template-menu/index.js